export default __webpack_public_path__ + "static/media/welcome-profile.7ff4f89a.png";